module.exports = __webpack_public_path__ + "img/pdf_reference_icon.42671547.svg";